/**
 * Newsletter subscription.
 * Placeholder until a backend endpoint exists — validates and resolves after a short delay.
 */
export const subscribe = async (email) => {
  if (!/\S+@\S+\.\S+/.test(email)) throw new Error('Invalid email');
  await new Promise((resolve) => setTimeout(resolve, 400));
  return { ok: true };
};
